<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="项目编号" prop="projectNo">
        <el-input v-model="search.projectNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="项目明细行号" prop="projectDetailLineNo">
        <el-input v-model="search.projectDetailNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="search.projectName" placeholder="模糊搜索" clearable></el-input>
      </el-form-item>
      <el-form-item label="回收订单" prop="recoveryOrder">
        <el-input v-model="search.recycleNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="旧机状态" prop="oldMachineStatusList">
        <el-select v-model="search.oldMachineStatusList" @change="handleOldMachineStatusChange" multiple placeholder="下拉多选" clearable>
          <el-option :label="item.description" :value="item.enumCode" v-for="item in BusinessOldMachineStatusEnum" :key="item.enumCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="网点编号" prop="siteNo">
        <el-input v-model="search.outletsNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="网点名称" prop="siteName">
        <el-input v-model="search.outletsName" placeholder="模糊搜索" clearable></el-input>
      </el-form-item>
      <el-form-item label="网点所属销司" prop="regionNo">
        <el-select v-model="search.regionNo" placeholder="下拉单选" clearable>
          <el-option v-for="(val, key) in regionOption" :key="key" :label="val.label" :value="val.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="冷量">
        <div class="range-num">
          <el-input-number v-model="search.startCoolNum" placeholder="起始值" style="width:50%;" controls-position="right" :min="0" :max="999999" clearable></el-input-number>
          <span>-</span>
          <el-input-number
            v-model="search.endCoolNum"
            placeholder="结束值"
            style="width:50%;"
            controls-position="right"
            :min="search.startCoolNum"
            :max="999999"
            clearable
          ></el-input-number>
        </div>
      </el-form-item>
      <el-form-item label="回收价格">
        <div class="range-num">
          <el-input-number v-model="search.startSinglePrice" placeholder="起始值" style="width:50%;" controls-position="right" :min="0" :max="999999" clearable></el-input-number>
          <span>-</span>
          <el-input-number
            v-model="search.endSinglePrice"
            placeholder="结束值"
            style="width:50%;"
            controls-position="right"
            :min="search.startSinglePrice"
            :max="999999"
            clearable
          ></el-input-number>
        </div>
      </el-form-item>
      <el-form-item label="旧机类型" prop="category">
        <el-select v-model="search.category" placeholder="联级选择" clearable @change="search.specification = ''">
          <el-option :label="key" :value="key" v-for="(val, key) in COMType" :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="旧机系列" prop="specification">
        <el-select v-model="search.specification" placeholder="联级选择" :disabled="!search.category" clearable>
          <el-option :label="item.specification" :value="item.specification" v-for="item in COMSeriesType" :key="item.specification"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商" prop="carrier">
        <el-select v-model="search.carrierNoList" placeholder="选择承运商" clearable multiple>
          <el-option v-for="item in carrierOption" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算状态" prop="settlementStatus">
        <el-select v-model="search.settleStatus" placeholder="下拉单选" clearable>
          <el-option :label="item.description" :value="item.enumCode" v-for="item in BusinessSettleStatusEnum" :key="item.enumCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="creationTime">
        <el-date-picker v-model="createdTime" value-format="yyyy-MM-dd" type="daterange" placeholder="日期区间" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="回收完成时间" prop="completionTime">
        <el-date-picker value-format="yyyy-MM-dd" v-model="completionTime" type="daterange" placeholder="日期区间" clearable></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
      <el-button size="medium" @click="resetForm()">重置</el-button>
      <el-button size="medium" @click="batchQuotation()">批量报价</el-button>
      <el-button size="medium" @click="batchSettle()">批量已结算</el-button>
      <el-button size="medium" @click="batchStorage()">批量再生资源入库</el-button>

      <el-button size="medium" @click="exportExcel()">导出</el-button>
    </div>
    <el-tabs @tab-click="tabChange()" v-model="tabStatus">
      <el-tab-pane label="全部" name="全部"></el-tab-pane>
      <el-tab-pane label="待报价" name="待报价"></el-tab-pane>
    </el-tabs>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="项目编号" prop="projectNo" width="200"></el-table-column>
      <el-table-column label="项目名称" prop="projectName" width="200"></el-table-column>
      <el-table-column label="项目明细行号" prop="projectDetailNo" width="200"></el-table-column>
      <el-table-column label="回收订单" prop="recycleNo" width="200"></el-table-column>
      <el-table-column label="条码" prop="barCode" width="200"></el-table-column>
      <el-table-column label="旧机状态" prop="oldMachineStatus" width="200" :formatter="formatOldMachineStatus"></el-table-column>
      <el-table-column label="结算状态" prop="settleStatus" width="200" :formatter="formatSettleStatus"></el-table-column>
      <el-table-column label="明细行回收价" prop="detailRecyclePrice" width="200"></el-table-column>
      <el-table-column label="单价" prop="singlePrice" width="200"></el-table-column>
      <el-table-column label="旧机品牌" prop="brandName" width="200"></el-table-column>
      <el-table-column label="旧机类型" prop="category" width="200"></el-table-column>
      <el-table-column label="旧机系列" prop="specification" width="200"></el-table-column>
      <el-table-column label="冷量" prop="coolNum" width="200"></el-table-column>
      <el-table-column label="年限" prop="useAge" width="200"></el-table-column>
      <el-table-column label="明细行旧机数量" prop="detailRecycleTotal" width="200"></el-table-column>
      <el-table-column label="是否拆机" prop="disassemble" width="200">
        <template slot-scope="scope">
          {{ scope.row.disassemble | BooleanStatus }}
        </template>
      </el-table-column>
      <el-table-column label="网点编号" prop="outletsNo" width="200"></el-table-column>
      <el-table-column label="网点名称" prop="outletsName" width="200"></el-table-column>
      <el-table-column label="网点所属销司" prop="regionName" width="200"></el-table-column>
      <el-table-column label="省" prop="province" width="200"></el-table-column>
      <el-table-column label="市" prop="city" width="200"></el-table-column>
      <el-table-column label="区" prop="county" width="200"></el-table-column>
      <el-table-column label="详细地址" prop="address" width="200"></el-table-column>
      <el-table-column label="联系人" prop="contactName" width="200"></el-table-column>
      <el-table-column label="联系电话" prop="contactMobile" width="200"></el-table-column>
      <el-table-column label="承运商" prop="carrierName" width="200"></el-table-column>
      <el-table-column label="承运商组织" prop="carrierOrg" width="200"></el-table-column>
      <el-table-column label="回收人员" prop="recoveryWorkerName" width="200"></el-table-column>
      <el-table-column label="创建时间" prop="createdDate" width="200"></el-table-column>
      <el-table-column label="报价完成时间" prop="reportPriceDate" width="200"></el-table-column>
      <el-table-column label="回收完成时间" prop="completeDate" width="200"></el-table-column>
      <el-table-column label="操作" fixed="right" width="300" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">旧机信息</el-button>

          <!-- 待结算(可结算)状态可以操作 -->
          <!-- <el-button
            type="text"
            v-show="scope.row.settleStatus == 0"
            @click="setSettlementStatus(scope.row)"
            >已结算</el-button
          > -->
          <!-- <el-button
            type="text"
            v-show="scope.row.oldMachineStatus == 600"
            @click="setStorageStatus(scope.row)"
            >再生资源入库</el-button
          > -->

          <el-upload
            v-if="!scope.row.reportPriceUrl"
            :show-file-list="false"
            :on-change="file => uploadQuoteFile(file, scope.row)"
            :auto-upload="false"
            :disabled="false"
            action="#"
          >
            <el-button size="small" type="text">上传报价单</el-button>
          </el-upload>

          <el-button v-else type="text" @click="downloadQuoteFile(scope.row)">下载报价单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.rows"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <commonBath
      ref="batchSettlementRef"
      @opera-success="getList"
      :failType="201"
      :errUrl="'/autoapp-default-server-recovery/api/file/downLoadFail'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/business/project/batchSettle/downLoadRTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/business/project/importBatchSettle'"
      :title="'批量结算'"
      :uploadTitle="'导入结算'"
    ></commonBath>
    <commonBath
      ref="batchQuotationRef"
      @opera-success="getList"
      :failType="200"
      :errUrl="'/autoapp-default-server-recovery/api/file/downLoadFail'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/business/project/batchReportPrice/downLoadRTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/business/project/importBatchReportPrice'"
      :title="'批量报价'"
      :uploadTitle="'导入报价'"
    ></commonBath>
    <commonBath
      ref="batchStorageRef"
      @opera-success="getList"
      :failType="202"
      :errUrl="'/autoapp-default-server-recovery/api/file/downLoadFail'"
      :importUrl="'/autoapp-default-server-recovery/api/business/project/importBatchWarehousing'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/business/project/batchWarehousing/downLoadRTemplate'"
      :title="'批量再生资源入库'"
      :uploadTitle="'导入入库'"
    ></commonBath>
    <searchOldDetailDialog ref="detailDialogRef"></searchOldDetailDialog>
  </div>
</template>
<script>
import { settlementOrder, storageOrder, getOldMachineList, getCarrierList, updateLoadReportPriceFile, getRegion } from '@/api/COldForNew'
import {} from '@/api/oldForNew'
import { orderTypeOption } from './mixin.js'
import commonBath from './components/commonBath.vue'
import searchOldDetailDialog from './components/searchOldDetailDialog'
import fileUpload from './components/FileUpload'
import enumMixin from './enumMixin.js'
import { getSignUp, upOssSave } from '@/api/file'
export default {
  name: 'searchOld',
  components: {
    searchOldDetailDialog,
    commonBath,
    // storageImportResultDialog,
    fileUpload
  },
  mixins: [enumMixin],
  computed: {
    COMSeriesType() {
      if (this.search.category) {
        return this.COMType[this.search.category]
      }
    }
  },
  data() {
    return {
      createdTime: [], //创建时间
      completionTime: [], //回收完成时间
      regionOption: [], // 销司列表
      list: [],
      total: null, //列表总条数
      listLoading: false,
      search: {
        page: 1,
        size: 10,
        projectNo: '',
        projectDetailNo: '',
        projectName: '',
        recycleNo: '',
        oldMachineStatusList: [],
        outletsNo: '',
        outletsName: '',
        regionNo: '', //网点所属销司
        startCoolNum: undefined,
        endCoolNum: undefined,
        startSinglePrice: undefined,
        endSinglePrice: undefined,
        category: '',
        specification: '',
        carrierNoList: [],
        settleStatus: undefined,
        startCreateDate: '',
        endCreateDate: '',
        startCompleteDate: '',
        endCompleteDate: ''
      },
      tabStatus: '全部',
      //工单类型
      orderTypeOption: orderTypeOption,
      carrierOption: [], //承运商选项列表
      hasOldOPtion: { 1: '是', 0: '否' }, //是否有待回收旧机
      oldMachineSpecMatchOption: { 1: '不匹配', 2: '匹配' },
      warehousingOption: { 0: '未入库', 1: '已入库' }, //再生资源入库状态
      salePlatformMap: {} //渠道类型
    }
  },
  async created() {
    //获取商用的承运商列表
    this.getCarrierOption()
    this.getRegionList()

    this.getList()
  },
  filters: {
    changeStatus(value, optionList) {
      return value ? (optionList.find(item => item.value == value) || {}).label || '' : ''
    },

    BooleanStatus(value) {
      if (value === 0) return '否'
      if (value === 1) return '是'
      return '--'
    }
  },
  methods: {
    handleSearch() {
      this.search.page = 1
      this.getList()
    },
    tabChange() {
      this.search.oldMachineStatusList = []
      if (this.tabStatus == '待报价') {
        this.search.oldMachineStatusList.push('100')
      }
      this.handleSearch()
    },
    handleOldMachineStatusChange() {
      if (this.search.oldMachineStatusList.length === 1 && this.search.oldMachineStatusList[0] === '100') {
        this.tabStatus = '待报价'
      } else {
        this.tabStatus = '全部'
      }
    },
    setTimeRange(timeRange, [startKey, endKey]) {
      if (timeRange && timeRange.length) {
        this.search[startKey] = timeRange[0] + ' 00:00:00'
        this.search[endKey] = timeRange[1] + ' 23:59:59'
      }
    },

    //获取销司
    async getRegionList() {
      let { statusCode, data } = await getRegion()
      if (statusCode == 200) {
        const list = data.data || []
        this.regionOption = list.map(item => {
          return {
            label: item.regionName,
            value: item.regionNo
          }
        })
      }
    },
    async getList() {
      if (this.createdTime && this.createdTime.length) {
        ;[this.search.startCreateDate, this.search.endCreateDate] = this.createdTime
        this.setTimeRange(this.createdTime, ['startCreateDate', 'endCreateDate'])
      } else {
        this.search.startCreateDate = this.search.endCreateDate = null
      }
      // 回收完成时间
      if (this.completionTime && this.completionTime.length) {
        ;[this.search.startCompleteDate, this.search.endCompleteDate] = this.completionTime
        this.setTimeRange(this.completionTime, ['startCompleteDate', 'endCompleteDate'])
      } else {
        this.search.startCompleteDate = this.search.endCompleteDate = null
      }
      let { statusCode, data, total } = await getOldMachineList(this.search)
      if (statusCode == 200) {
        this.list = data || []
        this.total = total || 0
      } else {
        this.list = []
      }
    },
    formatSettleStatus(row) {
      const status = this.BusinessSettleStatusEnum.find(item => item.enumCode == row.settleStatus)
      return status ? status.description : ''
    },
    formatOldMachineStatus(row) {
      const status = this.BusinessOldMachineStatusEnum.find(item => item.enumCode == row.oldMachineStatus)
      return status ? status.description : ''
    },
    goDetail(row) {
      if (row.id) {
        this.$refs.detailDialogRef.openDialog(row.id)
      }
    },
    resetForm() {
      this.search = this.$options.data().search
      this.completionTime = []
      this.createdTime = []
    },
    handleSizeChange(val) {
      this.search.page = 1
      this.search.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },

    //获取商用承运商列表
    async getCarrierOption() {
      const pagination = {
        currPage: 1,
        pageSize: 999
      }
      let res = await getCarrierList(pagination)
      if (res.statusCode == 200) {
        this.carrierOption = res.data || []
      }
    },
    //更改结算状态
    setSettlementStatus(row) {
      if (row.id) {
        this.$dialog({
          title: '已结算确认',
          content: '请确认旧机结算',
          cancel_buttton: '取消',
          ok_buttton: '确认',
          width: '400px',
          footBtn: 'card',
          dialogType: 'sighicon',
          onOk: () => {
            this.confirmSettlement(row.id)
          },
          onCancel: () => {
            console.log('cancel')
          }
        })
      }
    },
    //确认更改旧机结算状态
    async confirmSettlement(id) {
      let { statusCode } = await settlementOrder(id)
      if (statusCode == 200) {
        this.$message.success('操作成功')
        this.getList()
      }
    },
    setStorageStatus(row) {
      if (row.id) {
        this.$dialog({
          title: '再生资源入库确认',
          content: '请确认再生资源入库',
          cancel_buttton: '取消',
          ok_buttton: '确认',
          width: '400px',
          footBtn: 'card',
          dialogType: 'sighicon',
          onOk: () => {
            this.confirmStorage(row.id)
          },
          onCancel: () => {
            console.log('cancel')
          }
        })
      }
    },
    // 确认更改再生资源入库状态
    async confirmStorage(id) {
      let { statusCode } = await storageOrder(id)
      if (statusCode == 200) {
        this.$message.success('操作成功')
        this.getList()
      }
    },
    beforeUpload(file) {
      console.log('beforeUpload', file)

      const isLt2M = file.size / 1024 / 1024 <= 0.1
      if (!isLt2M) {
        this.$message.error(`上传报价单大小不能超过 50MB!`)
        return false
      }
      return true
    },
    //上传报价单
    async uploadQuoteFile(file, row) {
      const isLt2M = file.size / 1024 / 1024 <= 50

      if (!isLt2M) {
        this.$message.error(`上传报价单大小不能超过 50MB!`)
        return
      }
      const signUpResult = await getSignUp() //获取签名
      if (signUpResult.statusCode == 200) {
        console.log('signUpResult.data', signUpResult.data)
        const { accessid, dir, expire, policy, signature } = signUpResult.data
        const keyStr = `${dir}${file.name}`
        const formData = new FormData()

        formData.append('key', keyStr)
        formData.append('OSSAccessKeyId', accessid)
        formData.append('policy', policy)
        formData.append('Signature', signature)
        formData.append('Expires', expire)
        formData.append('successActionStatus', 200)
        formData.append('file', file.raw)

        //上传到 oss
        upOssSave(formData).then(async res => {
          let { data, statusCode, message } = await updateLoadReportPriceFile(row.projectNo, file.name)

          if (statusCode == 200) {
            this.$message.success('上传成功!')
            this.getList()
          } else {
            this.$message.error(message || '后台报错请联系管理员')
          }
        })
      }
    },
    //下载报价单
    async downloadQuoteFile(row) {
      let url = process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${row.reportPriceUrl}`

      window.open(url, '_blank')
    },
    //批量已结算
    batchSettle() {
      this.$refs.batchSettlementRef.openDialog()
    },
    //批量已结算
    batchQuotation() {
      this.$refs.batchQuotationRef.openDialog()
    },
    //批量入库
    batchStorage() {
      this.$refs.batchStorageRef.openDialog()
    },
    exportExcel() {
      this.exportBtnLoading = true

      const url = '/autoapp-default-server-recovery/api/business/project/export/pageCondition'
      const title = '商用旧机查询'

      const startCreateDate = this.createdTime[0] ? `${this.createdTime[0]} 00:00:00` : undefined
      const endCreateDate = this.createdTime[1] ? `${this.createdTime[1]} 23:59:59` : undefined
      const startCompleteDate = this.completionTime[0] ? `${this.completionTime[0]} 00:00:00` : undefined
      const endCompleteDate = this.completionTime[1] ? `${this.completionTime[1]} 23:59:59` : undefined

      const params = {
        ...this.search,
        startCreateDate,
        endCreateDate,
        startCompleteDate,
        endCompleteDate,
        ...this.pagination
      }
      this.global
        .exportExcel(url, params, title)
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: 'application/json'
          })
          var blobReader = new Response(blob).json()
          blobReader.then(res => {
            this.$message.error(res.message)
          })
        })
        .finally(() => {
          this.exportBtnLoading = false
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  display: flex;
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
.batch-storage-button {
  margin-left: 10px;
  margin-right: 10px;
}
.show-other-search {
  display: flex;
  // justify-content: flex-end;
  padding-bottom: 16px;
  .show-other-search-btn {
    cursor: pointer;
    color: #00b882;
    .show-btn-icon {
      margin-right: 5px;
    }
  }
}
.range-num {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 207.42px;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.range-num /deep/.el-input__inner {
  border: none !important;
}
.range-num /deep/.el-input-number__increase,
.range-num /deep/.el-input-number__decrease {
  display: none;
}
.range-num /deep/.el-input-number.is-controls-right .el-input__inner {
  padding-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/searchOld.vue